import * as types from 'modules/interventions/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @typedef {boolean} State */

/** @type State */
const initialState = false;

/**
 * @returns {State}
 */
const isLoading = () => true;

/**
 * @returns {State}
 */
const isEnding = () => false;

export default createReducer(initialState, {
  [types.APPROVE_MANUALLY_REQUEST]: isLoading,
  [types.APPROVE_MANUALLY_SUCCESS]: isEnding,
  [types.APPROVE_MANUALLY_FAILURE]: isEnding,
});
